import { render } from "./ListEquipUsados.vue?vue&type=template&id=15e10a82"
import script from "./ListEquipUsados.vue?vue&type=script&lang=js"
export * from "./ListEquipUsados.vue?vue&type=script&lang=js"

import "./ListEquipUsados.vue?vue&type=style&index=0&id=15e10a82&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__